import CalenderStyled from 'components/CalenderStyled/CalenderStyled'
import {
  addDays,
  addWeeks,
  endOfWeek,
  format,
  startOfWeek,
  subDays,
  subWeeks,
} from 'date-fns'
import {
  getEventByEventID,
  getListofEventsForCollege,
  getListofEventsFiltersForCollege
} from 'modules/Events/actions'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import Header from './Header'
import { MainWrapper, MiniCalWidth } from './Header/style'
import ActionModal from './ListView/List/Components/ActionModal'
import EventDetails from './Partials/EventDetails'
import PreviewDrawer from './Preview/Partials/Drawer/PreviewDrawer'

export const categoryBasedStyle = status => {
  switch (status) {
    case 'EXHIBITION':
      return {
        color: '#ffffff',
        bgColor: 'rgb(89 95 51 / 20%)',
        borderColor: '#595F33',
        status: 'Exhibition',
      }
    case 'ACTIVITY_EVENT':
      return {
        color: '#ffffff',
        bgColor: 'rgba(2, 69, 122, 0.2)',
        borderColor: '#02457A',
        status: 'Activity/Event',
      }
    case 'SPORTS_EVENT':
      return {
        color: '#ffffff',
        bgColor: 'rgb(19 89 63 / 20%)',
        borderColor: '#13593F',
        status: 'Sports/Event',
      }
    case 'CAMPAIGN':
      return {
        color: '#ffffff',
        bgColor: 'rgba(223, 147, 255, 0.25)',
        borderColor: '#4C1D91',
        status: 'Campaign',
      }
    case 'WORKSHOP':
      return {
        color: '#000000',
        bgColor: 'rgb(114 176 111 / 20%)',
        borderColor: '#72B06F',
        status: 'Workshop',
      }
    case 'HACKATHON':
      return {
        color: '#000000',
        bgColor: 'rgb(49 170 181 / 20%)',
        borderColor: '#31AAB5',
        status: 'Hackathon',
      }
    case 'PANEL_DISCUSSION':
      return {
        color: '#ffffff',
        bgColor: 'rgb(242 92 5 / 20%)',
        borderColor: '#F25C05',
        status: 'Panel Discussion',
      }
    case 'CONFERENCE':
      return {
        color: '#000000',
        bgColor: 'rgb(242 159 5 / 25%)',
        borderColor: '#F29F05',
        status: 'Conference',
      }
    case 'LECTURE':
      return {
        status: 'Lecture',
        bgColor: 'rgb(141 106 160 / 20%)',
        borderColor: '#8D6AA0',
        color: '#000000',
      }
    case 'WEBINAR':
      return {
        status: 'Webinar',
        bgColor: 'rgba(255, 182, 193, 0.25)',
        borderColor: '#E1A7BA',
        color: '#000000',
      }
    case 'SEMINAR':
      return {
        status: 'Seminar',
        bgColor: 'rgba(181, 163, 247, 0.25)',
        borderColor: '#B5A3F7',
        color: '#000000',
      }
    case 'PRE_PLACEMENT_TALK':
      return {
        status: 'Pre Placement Talk',
        bgColor: 'rgb(151 202 219 / 20%)',
        borderColor: '#97CADB',
        color: '#000000',
      }
    case 'OTHERS':
      return {
        status: 'Others',
        borderColor: 'rgba(0, 27, 72, 1)',
        bgColor: 'rgba(0, 27, 72, 0.2)',
        color: '#ffffff',
      }
    default:
      return {
        color: '#000000',
        bgColor: '#F3F3F3',
        borderColor: '#00000045',
        status: status,
      }
  }
}
export const formatDateWithOrdinal = (date, formatType) => {
  const day = Number(format(date, 'd')) // Convert to number
  const monthYear =
    formatType == 'month' ? format(date, 'MMM') : format(date, 'MMMM, yyyy')

  const getOrdinalSuffix = day => {
    if (day > 3 && day < 21) return 'th'
    switch (day % 10) {
      case 1:
        return 'st'
      case 2:
        return 'nd'
      case 3:
        return 'rd'
      default:
        return 'th'
    }
  }

  const dayWithSuffix = day + getOrdinalSuffix(day)
  return `${dayWithSuffix} ${monthYear}`
}

export function Debounce(fn, delay) {
  let timer
  return function () {
    let context = this,
      args = arguments
    clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(context, args)
    }, delay)
  }
}

const typeLabels = {
  OTHERS: 'Others',
  PRE_PLACEMENT_TALK: 'Pre Placement Talk',
  SEMINAR: 'Seminar',
  WEBINAR: 'Webinar',
  LECTURE: 'Lecture',
  CONFERENCE: 'Conference',
  PANEL_DISCUSSION: 'Panel Discussion',
  HACKATHON: 'Hackathon',
  WORKSHOP: 'Workshop',
  CAMPAIGN: 'Campaign',
  SPORTS_EVENT: 'Sports Event',
  ACTIVITY_EVENT: 'Activity / Event',
  EXHIBITION: 'Exhibition',
}
const Events = () => {
  const dispatch = useDispatch()
  const [isDrawerVisible, setIsDrawerVisible] = useState(false)
  const calenderView = 'right'
  const listView = 'left'
  const today = format(new Date(), 'yyyy-MM-dd')
  const [listDate, setListDate] = useState(today)
  const [fromDate, setFromDate] = useState(null)
  const [calenderData, setCalenderData] = useState([])
  const [eventList, setEventList] = useState([])
  const [modalContent, setModalContent] = useState({ image: '', text: '' })
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [selectedEvent,setSelectedEvent] = useState(null)
  const [uniqueYears, setUniqueYears] = useState([]);
  const [degreeOptions, setDegreeOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [departmentOptionSet, setDepartmentOptionSet] = useState([]);
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [selectedDegree, setSelectedDegree] = useState([])
  // Specialization filter - commented out as no longer needed
  // const [selectedSpecialization, setSelectedSpecialization] = useState([])
  // const [specializationOptions, setSpecializationOptions] = useState([])
  const [renderState, setRenderState] = useState(false)
  const [draftCount, setDraftCount] = useState(0)

  const [state, setState] = useState({
    pageNo: 0,
    pageLimit: 50,
    from: listDate,
    category: '',
    occurence: 'UPCOMING',
    forCalendar: true,
    forRegisterEvent: false,
    status: '',
    search: '',
    degree: [],
    department: [],
    selectedCategory: [],
    eventsList: [],
    eventListCurrentObj: null,
    dateList: [listDate],
    year: '',
    selectedYear: [],
    sort: 'showAll',
    loading: false,
    hasMoreData: true,
    forRecentlyAdded: false,
    previewClose: false,
    selectedEvent: [],
    selectedEventCategory: '',
    stdDetailsDrawerOpen: false,
    currentToggle: 'right',
    sortBy: 'showAll',
    eventStatus: 'PUBLISHED',
  })


  const [selectedCategory, setSelectedCategory] = useState([])
  const formattedListDate = formatDateWithOrdinal(new Date(listDate))
  const calendarRef = useRef(null)
  const menuRef = useRef(null)
    const getAdjustedDate = () => {
      const today = new Date()
      if (state.currentToggle === listView) {
        return today
      } else {
        return endOfWeek(today, { weekStartsOn: 0 })
      }
    }
    const [currentWeekStart, setCurrentWeekStart] = useState(
      startOfWeek(new Date(), { weekStartsOn: 0 })
    )
    const [currentWeekEnd, setCurrentWeekEnd] = useState(getAdjustedDate)
  const [showMiniCalendar, setShowMiniCalendar] = useState(false)

  const menu = (
    <MiniCalWidth ref={menuRef}>
      <CalenderStyled
        setFromDate={state.currentToggle == 'left' ? setListDate : setFromDate}
        fromDate={state.currentToggle == 'left' ? listDate : fromDate}
        listView={state.currentToggle == 'left'}

      />
    </MiniCalWidth>
  )

  useEffect(() => {
if(listDate && state.currentToggle == 'left'){
  handleCaptureChange(listDate)
}
  },[listDate])
  const handleCaptureChange = data => {
    let currentDate = new Date(today)
    let clickedDate = new Date(data)
    let occurence = clickedDate < currentDate ? 'PAST' : 'UPCOMING'
     
      fetchEventsList({ from: data, pageNo: 0, occurence: occurence, forCalendar:false,  degree:selectedDegree,department:selectedDepartment,category:selectedCategory,year: selectedYear  })
    setState(prev => ({
      ...prev,
      occurence: occurence,
      hasMoreData: true,
      from: data,
    }))
    setShowMiniCalendar(false)
  }
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMiniCalendar(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (fromDate != null) {
      const newStart = startOfWeek(fromDate, { weekStartsOn: 0 });
      const newEnd = endOfWeek(fromDate, { weekStartsOn: 0 });
      setCurrentWeekStart(newStart);
      setCurrentWeekEnd(newEnd);
      if (calendarRef?.current) {
        const calendarApi = calendarRef.current?.getApi()
        calendarApi.gotoDate(newStart)
      }
      setShowMiniCalendar(false)
    }
  }, [fromDate]);

  useEffect(() => {
    fetchDraftCount()
  },[state.eventStatus,state])

  const fetchDraftCount = async() =>{
    let payload = {
      "forCalendar": false,
      "eventStatus":  'DRAFT',
        "pageNo": 0,
        "pageLimit": 50,

        "category": [],
        "year": [],
        "degree": [],
        "department": [],
        "occurence": "UPCOMING",
        "forRegisterEvent": false,
        "status": "",
        "search": "",
        "sort": "showAll",
        "forRecentlyAdded": false,
    
    }
    
  const response = await dispatch(getListofEventsForCollege(payload))
  setDraftCount(response?.count)
  }
  const fetchEventsList = async ({
    pageNo = state.pageNo,
    pageLimit = state.pageLimit,
    from = state.from,
    category = state.selectedCategory,
    occurence = state.occurence,
    year = state.selectedYear,
    degree = state.selectedDegree,
    department= state.department,
    forCalendar = state.forCalendar,
    forRegisterEvent = state.forRegisterEvent,
    status = state.status,
    search = state.search,
    loadMore = false,
    sort = state?.sort,
    forRecentlyAdded = state?.forRecentlyAdded,
    eventStatus = state.eventStatus
  } = {}) => {
    const idSelectedArr = department
    .filter(item => item.includes(' ') && item.split(' ')[0])
    .map(item => {
      const id = item.split(' ')
      return id[1]
    })
  const selectedDept = idSelectedArr?.join(',')
    try {
      let payload = {
        pageNo: pageNo,
        pageLimit: pageLimit,
        from: from,
        category: category,
        year: year,
        degree: degree,
        department: selectedDept,
        occurence: occurence,
        forCalendar:  forCalendar,
        forRegisterEvent: forRegisterEvent,
        status: status,
        search: search,
        sort: sort,
        forRecentlyAdded: forRecentlyAdded,
        eventStatus:  eventStatus
      }

      setState(prev => ({
        ...prev,
        loading: !loadMore,
      }))

      const response = await dispatch(getListofEventsForCollege(payload))
      setEventList(response)
      const eventListCurrentObj = response
      const newEvents = response?.result
      setCalenderData(newEvents)
      if (eventListCurrentObj && Array.isArray(newEvents)) {
        const list = loadMore
          ? [...(state?.eventsList || []), ...newEvents]
          : [...newEvents]

const fullList = list.map(event => ({
  ...event,
  startDate1: event.startDate ,
  endDate1: event.endDate 
}));
          const expandedList = fullList.flatMap(event => {
            const start = event?.startDate?.split('T')[0];
            const end = event?.endDate?.split('T')[0];
          
            if (start !== end) {
              return splitMultiDayEvent(event);
            }
            return event;
          });
          const groupedEvents = expandedList.reduce((acc, event) => {
            const eventDate = event.startDate ? format(new Date(event.startDate), 'yyyy-MM-dd') : 'noDate';
            if (!acc[eventDate]) {
              acc[eventDate] = [];
            }
            acc[eventDate].push(event);
            return acc;
          }, {});
          for (const date in groupedEvents) {
            groupedEvents[date].sort((a, b) => {
              // If both are all-day events or both are not all-day events, maintain order
              if (a.allDayEvent === b.allDayEvent) {
                return 0;
              }
              // If a is all-day and b is not, a comes first
              if (a.allDayEvent) {
                return -1;
              }
              // If b is all-day and a is not, b comes first
              return 1;
            });
          }
        const eventList = eventStatus === 'DRAFT' || forRecentlyAdded ? 
        [{
            date: 'noDate', eventsList: fullList
          }] :
          filterEventsByOccurrence(groupedEvents, occurence, from);
   
        setState(prevState => ({
          ...prevState,
          eventListCurrentObj,
          eventsList: list,
          eventFullList:  eventList,
        }))
      }
      return response
    } catch (error) {
      console.error('Error fetching events:', error)
    } finally {
      setTimeout(() => {
        setState(prev => ({
          ...prev,
          loading: false,
        }))
      }, 1000)
    }
  }
  const filterEventsByOccurrence = (groupedEvents, occurrence, currentDate) => {
    const comparisonDate = new Date(currentDate);
  
    return Object.entries(groupedEvents)
      .filter(([date, events]) => {
        const eventDate = new Date(date);
        if (occurrence === 'UPCOMING') {
          return eventDate >= comparisonDate; // Include current and future dates
        } else if (occurrence === 'PAST') {
          return eventDate <= comparisonDate; // Include only past dates
        }
        return true; // Default case, if occurrence is neither UPCOMING nor PAST
      })
      .sort(([dateA], [dateB]) => {
        const eventDateA = new Date(dateA);
        const eventDateB = new Date(dateB);
        if (occurrence === 'UPCOMING') {
          return eventDateA - eventDateB; // Sort in ascending order for upcoming events
        } else if (occurrence === 'PAST') {
          return eventDateB - eventDateA; // Sort in descending order for past events
        }
        return 0;
      })
      .map(([date, events]) => ({ date: date, eventsList: events }));
  };


  const splitMultiDayEvent = event => {
    const start = new Date(event.startDate);
    const end = new Date(event.endDate);
    const startDateOnly = new Date(start.toISOString().split('T')[0]);
    const endDateOnly = new Date(end.toISOString().split('T')[0]);
    const days = Math.ceil((endDateOnly - startDateOnly) / (1000 * 60 * 60 * 24)) + 1;
    const eventDays = [];
  
    for (let i = 0; i < days; i++) {
      const currentDate = new Date(startDateOnly.getTime() + i * (1000 * 60 * 60 * 24));
      const eventDay = {
        ...event,
        startDate: currentDate.toISOString(),
        endDate: currentDate.toISOString(),
      };
  
      if (i === 0) {
        eventDay.startDate = start.toISOString();
      }
      if (i === days - 1) {
        eventDay.endDate = end.toISOString();
      }
  
      eventDays.push(eventDay);
    }
  
    return eventDays;
  };
  const handleOccurrenceClick = async occurrence => {
    const newDate =
      occurrence == 'UPCOMING'
        ? addDays(new Date(today), 0)
        : subDays(new Date(today), 1)
    const formattedNewDate = format(newDate, 'yyyy-MM-dd')
    setListDate(formattedNewDate)
    setState(prev => ({
      ...prev,
      occurence: occurrence,
      hasMoreData: true,
      pageNo: 0,
     
      
    }))
  }

  const handleDrawerClose = () => {
    setSelectedEvent(null)
    setIsDrawerVisible(false) // Set drawer visibility to false on 
    setState(prev => ({
      ...prev,
      pageNo: 0,
      hasMoreData: true,
    }))
    if(state?.currentToggle === "left" && renderState){
      fetchEventsList({ pageNo: 0, search: '', forCalendar: false })
      setRenderState(false)
    }
   else if(state?.eventStatus === "DRAFT" && renderState){
      fetchEventsList({ pageNo: 0, search: '', eventStatus:'DRAFT', forCalendar: false })
      setRenderState(false)
    
    }
    else if(renderState){

      setState(prev => ({
        ...prev,
        pageNo: 0,
        hasMoreData: true,
        forCalendar: true

      }))
      fetchEventsList({
        pageNo: 0,
        hasMoreData: true,
        forCalendar: true
      })
      setRenderState(false)

    }

  }
  const handleSortByChange = async value => {
    setState(prev => ({
      ...prev,
      forRecentlyAdded: value == 'forRecentlyAdded' ? true : false,
      forRegisterEvent: value == 'forRegisterEvent' ? true : false,
      sort: value,
      hasMoreData: true,
      degree:selectedDegree,department:selectedDepartment,category:selectedCategory,year: selectedYear
    }))
    fetchEventsList({
      pageNo: 0,
      forRecentlyAdded: value == 'forRecentlyAdded' ? true : false,
      forRegisterEvent: value == 'forRegisterEvent' ? true : false,
      // occurence: occurrence,
      sort: value,
      forCalendar: false,
      degree:selectedDegree,department:selectedDepartment,category:selectedCategory,year: selectedYear
    })
  }

  const handleSingleEventClick = async (data, action) => {
    if (data) {
      const response = await fetchEventDetailsById(data?.id)      
      if(response !== false){
        setIsDrawerVisible(true)
      setSelectedEvent(response)
      }
      else
      {
      setIsDrawerVisible(false)
      setSelectedEvent([])
      }
    }
  }



  const fetchEventDetailsById = async id => {
    try {
      const response = await dispatch(getEventByEventID({ eventId: id }))
      if (response?.data?.message == 'Success') {
        return response?.data?.data
      } else {
        return false
      }
    } catch (err) {
      //
    }
  }

  const handlePrevWeek = () => {
    if (state.currentToggle === calenderView) {
      const newStart = subWeeks(currentWeekStart, 1)
      const newEnd = subWeeks(currentWeekEnd, 1)
      setCurrentWeekStart(newStart)
      setCurrentWeekEnd(newEnd)
      const calendarApi = calendarRef.current.getApi()
      calendarApi.gotoDate(newStart)
    } 
    else {
      const newDate = subDays(new Date(listDate), 1)
      const formattedNewDate = format(newDate, 'yyyy-MM-dd')
      setListDate(formattedNewDate)
      let currentDate = new Date(today)
      let clickedDate = new Date(formattedNewDate)
      let occurence = clickedDate < currentDate ? 'PAST' : 'UPCOMING'
      fetchEventsList({
        from: formattedNewDate,
        pageNo: 0,
        loadMore: false,
        occurence: occurence,
        forCalendar: false,
      })
      setState(prev => ({
        ...prev,
        pageNo: 0,
        hasMoreData: true,
        occurence: occurence,
        from: formattedNewDate,
      
      }))
    }
  }

  const handleNextWeek = () => {
    if (state.currentToggle === calenderView) {
      const newStart = addWeeks(currentWeekStart, 1)
      const newEnd = addWeeks(currentWeekEnd, 1)
      setCurrentWeekStart(newStart)
      setCurrentWeekEnd(newEnd)
      const calendarApi = calendarRef.current.getApi()
      calendarApi.gotoDate(newStart)
    } else {
      const newDate = addDays(new Date(listDate), 1)
      const formattedNewDate = format(newDate, 'yyyy-MM-dd')
      setListDate(formattedNewDate)
      let currentDate = new Date(today)
      let clickedDate = new Date(formattedNewDate)
      let occurence = clickedDate >= currentDate ? 'UPCOMING' : 'PAST'
      fetchEventsList({
        from: formattedNewDate,
        pageNo: 0,
        loadMore: false,
        occurence: occurence,
        forCalendar: false,

      })
      setState(prev => ({
        ...prev,
        pageNo: 0,
        hasMoreData: true,
        occurence: occurence,
        from: formattedNewDate,

      }))
    }
  }

  const toggleMiniCalendar = () => {
    setShowMiniCalendar(!showMiniCalendar)
  }
  const handleCategoryChange = (value, label, extra) => {
    let selectedItem = []
    const selectedNodeProps = extra.triggerNode.props
    if (selectedNodeProps?.value == 'showAll') {
      selectedItem = selectedNodeProps?.children?.map(item => item.props?.value)
    } else {
      selectedItem = value
    }
    const selectedCat = selectedItem?.join(',')
    setState(prev => ({
      ...prev,
      selectedCategory: selectedCat,
      hasMoreData: true,
      currentToggle: listView,
      pageNo: 0,
      degree:selectedDegree,department:selectedDepartment,year: selectedYear
    }))
    setSelectedCategory(value)
    fetchEventsList({ category: selectedCat, pageNo: 0, forCalendar: false , degree:selectedDegree,department:selectedDepartment,year: selectedYear})
  }
  const handleDepartmentChange = (value, label, extra) => {

       
    setState(prev => ({
      ...prev,
      department: value,
      hasMoreData: true,
      currentToggle: listView,
      pageNo: 0,
    }));
    setSelectedDepartment(value);
  
    fetchEventsList({ department: value, degree: selectedDegree, category: selectedCategory, year: selectedYear, pageNo: 0, forCalendar: false });
  };


  const handleYearChange = (value, label, extra) => {
    let selectedItem = []
    
    if (extra?.triggerNode?.props) {
      const selectedNodeProps = extra.triggerNode.props
      if (selectedNodeProps?.value == 'showAll') {
        selectedItem = selectedNodeProps?.children?.map(item => item.props?.value)
      } else {
        selectedItem = value
      }
    } else {
      selectedItem = value
    }
    
    const selectedYear = selectedItem?.join(',')
    setState(prev => ({
      ...prev,
      selectedYear: selectedYear,
      hasMoreData: true,
      currentToggle: listView,
      pageNo: 0,
    }))
    setSelectedYear(value)
    fetchEventsList({ year: selectedYear, degree:selectedDegree,department:selectedDepartment, pageNo: 0, forCalendar: false })
  }
  
  
  const handleToggleChange = data => {
    setListDate(today)
    setState(prev => ({
      ...prev,
      search: '',
      currentToggle: data,
      pageNo: 0,
      occurence: 'UPCOMING',
      hasMoreData: true,
    }))
    fetchEventsList({
      search: '',
      forCalendar: data === listView ? false : true,
      pageNo: 0,
      occurence: 'UPCOMING',
      from: today,
    })
  }
  const handleDegreeChange = (value, label, extra) => {
    let selectedItem = [];
    const selectedNodeProps = extra.triggerNode.props;
  
    if (selectedNodeProps?.value == 'showAll') {
      selectedItem = selectedNodeProps?.children?.map(item => item.props?.value);
    } else {
      selectedItem = value;
    }
  
    setState(prev => ({
      ...prev,
      degree: selectedItem,
      hasMoreData: true,
      currentToggle: listView,
      pageNo: 0,
    }));
    setSelectedDegree(value);
  const result = filterFirstLevelChildren(departmentOptions, value);
  setSelectedDepartment([])
  setDepartmentOptionSet([result])
    fetchEventsList({ degree: selectedItem, category: selectedCategory, year: selectedYear, pageNo: 0, forCalendar: false });
  };
  
  function filterFirstLevelChildren(data, selectedDegrees) {

    const filteredChildren = data?.[0]?.children?.reduce((acc, child) => {
      if (selectedDegrees.includes(child.value)) {
        acc.push({
          ...child,
          children: child?.children // Ensure no nested children are included
        });
      }
      return acc;
    }, []);

  const processedData =   transformData(filteredChildren)

    return {    title: 'Show All',
    value: 'showAll', children: processedData ?? [] };
  }
  const transformData = (data) => {
    return data?.map(parent => ({
        ...parent,
        children: parent?.children?.map(child => ({
            ...child,
            value: `${parent?.value} ${child?.value}`
        }))
    }));
};

  const handleSearch = data => {
    setState(prev => ({
      ...prev,
      search: data,
      hasMoreData: true,
      pageNo: 0,
      currentToggle: 'left',
      degree:selectedDegree,department:selectedDepartment,category:selectedCategory,year: selectedYear 
    }))

    if(state?.eventStatus === "DRAFT"){
      fetchEventsList({ pageNo: 0, search: data, forCalendar: false })
    
    }
    else
    {
      
     fetchSearchedEvents(data)

    }
  }


  const fetchSearchedEvents = useCallback(
    Debounce((searchTerm) => {
      fetchEventsList({
        pageNo: 0,
        search: searchTerm,
        from: listDate,
        forCalendar: false,
        degree: selectedDegree,
        department: selectedDepartment,
        category: selectedCategory,
        year: selectedYear,
      });
    }, 1000),
    [state.pageNo, listDate, selectedDegree, selectedDepartment, selectedCategory, selectedYear]
  );



  const handleCloseModal = () => {
    setModalContent({
      image: '',
      text: '',
      actionType: '',
    })
    setIsModalVisible(false)
  }
  const handleConfirmAction = () => {}

  // Specialization change handler - commented out as no longer needed
  // const handleSpecializationChange = (value, label, extra) => {
  //   setSelectedSpecialization(value)
  //   fetchEventsList({ 
  //     specialization: value, 
  //     pageNo: 0, 
  //     forCalendar: false, 
  //     degree: selectedDegree,
  //     department: selectedDepartment,
  //     year: selectedYear,
  //     category: selectedCategory
  //   })
  // }

  const handleDraftChange = () => {
    setState(prev => ({
      ...prev,
      search: '',
      eventStatus: 'DRAFT',
      currentToggle: '',
    }))
    fetchEventsList({ pageNo: 0,search:'', eventStatus:'DRAFT',  forCalendar:false });
  }
  const handleDraftRemove = () => {
    setState(prev => ({
      ...prev,
      eventStatus: 'PUBLISHED',
      currentToggle: 'left',
      search: ''
    }))
    fetchEventsList({ pageNo: 0,search:'', eventStatus:'PUBLISHED',  forCalendar:false });
  }

  useEffect(() => {
    fetchEventsList()
  }, [])

  useEffect(() => {
    ;(async () => {
       await  dispatch(getListofEventsFiltersForCollege())
  
    })()

    return () => {
      // this now gets called when the component unmounts
    }
  }, [])


  useEffect(() => {
    dispatch(getListofEventsFiltersForCollege())
      .then(DataList => {
        if (DataList?.uniqueYears) {
          const yearData = DataList.uniqueYears.map(year => ({
            title: year,
            value: year
          }));

          setUniqueYears(yearData);
        } else {
          console.error('No uniqueYears found in DataList');
        }
      })
      .catch(error => {
        console.error('Error fetching event filters:', error);
      });
  }, [dispatch]);

 


  

  useEffect(() => {
    dispatch(getListofEventsFiltersForCollege())
      .then(DataList => {
        if (DataList?.uniqueDegreeStreamIds) {
          const uniqueDegreeStreamIds = DataList.uniqueDegreeStreamIds;
          const transformedData = Object.entries(uniqueDegreeStreamIds).map(([degreeName, degreeDetails]) => ({
            title: degreeName,
            value: degreeDetails?.id,
            children: degreeDetails.streams.map(stream => ({
              title: stream.name,
              value: stream.name
            }))
          }));
          const degreeOptionsWithShowAll = transformedData?.length > 0 ? [
            {
              title: 'Show All',
              value: 'showAll',
              children: transformedData.map(degree => ({
                title: degree.title,
                value: degree.value,
                // children: degree.children
              }))
            }
          ] : []
          setDegreeOptions(degreeOptionsWithShowAll);
        } else {
          console.error('No uniqueDegreeStreamIds found in DataList');
        }
      })
      .catch(error => {
        console.error('Error fetching event filters:', error);
      })
  }, [dispatch])


  useEffect(() => {
    dispatch(getListofEventsFiltersForCollege())
      .then(DataList => {
        if (DataList?.uniqueDegreeStreamIds) {
          const uniqueDegreeStreamIds = DataList.uniqueDegreeStreamIds;
  
          // Creating options for degrees and their streams
          const departmentOptionsWithShowAll = [
            {
              title: 'Show All',
              value: 'showAll',
              children: Object.entries(uniqueDegreeStreamIds).map(([degreeName, degree]) => ({
                title: degreeName,
                value: degree.id,
                children: degree.streams.map(stream => ({
                  title: stream.name,
                  value: stream.id
                }))
              }))
            }
          ]
  
          setDepartmentOptions(departmentOptionsWithShowAll);
  
        } else {
          console.error('No uniqueDegreeStreamIds found in DataList');
        }
      })
      .catch(error => {
        console.error('Error fetching event filters:', error);
      });
  }, [dispatch]);

  // Specialization processing useEffect - commented out as no longer needed
  // useEffect(() => {
  //   dispatch(getListofEventsFiltersForCollege())
  //     .then(DataList => {
  //       if (DataList?.uniqueDegreeStreamIds && selectedDegree?.length > 0) {
  //         const uniqueDegreeStreamIds = DataList.uniqueDegreeStreamIds;
  //         
  //         // Extract specializations from selected degrees
  //         const specializationOptionsWithShowAll = [
  //           {
  //             title: 'Show All',
  //             value: 'showAll',
  //             children: []
  //           }
  //         ];

  //         // Build specialization options from selected degrees
  //         Object.entries(uniqueDegreeStreamIds).forEach(([degreeName, degree]) => {
  //           // Check if this degree is in selectedDegree
  //           if (selectedDegree.includes(degree.id) || selectedDegree.includes(degreeName)) {
  //             if (degree.specialisations && degree.specialisations.length > 0) {
  //               const degreeSpecializations = degree.specialisations.map(spec => ({
  //                 title: `${degreeName} - ${spec.name}`,
  //                 value: spec.id
  //               }));
  //               specializationOptionsWithShowAll[0].children.push(...degreeSpecializations);
  //             }
  //           }
  //         });

  //         setSpecializationOptions(specializationOptionsWithShowAll);
  //         
  //         console.log('Specialization options processed:', {
  //           selectedDegree,
  //           specializationOptionsWithShowAll,
  //           totalSpecializations: specializationOptionsWithShowAll[0].children.length
  //         });
  //       } else {
  //         setSpecializationOptions([]);
  //       }
  //     })
  //     .catch(error => {
  //       console.error('Error fetching specialization filters:', error);
  //     });
  // }, [dispatch, selectedDegree]);
  
  const [uniqueCategories, setUniqueCategories] = useState([]);

  useEffect(() => {
    dispatch(getListofEventsFiltersForCollege())
      .then(DataList => {
        if (DataList?.uniqueCategories) {
          const uniqueCategories = DataList.uniqueCategories;

          const transformedData = uniqueCategories.map(category => ({
            title: typeLabels[category],
            value: category
          }));
          const categoriesOptionsWithShowAll = transformedData?.length > 0 ?  [
            {
              title: 'Show All',
              value: 'showAll',
              children: transformedData
            }
          ] : []

          setUniqueCategories(categoriesOptionsWithShowAll);
        } else {
          console.error('No uniqueCategories found in DataList');
        }
      })
      .catch(error => {
        console.error('Error fetching event filters:', error);
      });
  }, [dispatch]);
  
  return (
      <MainWrapper column>
        <Header
          menu={menu}
          handlePrevWeek={handlePrevWeek}
          handleNextWeek={handleNextWeek}
          toggleMiniCalendar={toggleMiniCalendar}
          handleCategoryChange={handleCategoryChange}
          showMiniCalendar={showMiniCalendar}
          handleToggleChange={handleToggleChange}
          formattedListDate={formattedListDate}
          currentWeekStart={currentWeekStart}
          currentWeekEnd={currentWeekEnd}
          selectedCategory={selectedCategory}
          selectedYear={selectedYear}
          state={state}
          handleDraftChange={handleDraftChange}
          handleDraftRemove={handleDraftRemove}
          setShowMiniCalendar={setShowMiniCalendar}
          uniqueYears={uniqueYears}
          degreeOptions={degreeOptions}
          departmentOptions={departmentOptions}
          departmentOptionSet={departmentOptionSet}
          uniqueCategories={uniqueCategories}
          handleYearChange={handleYearChange}
          handleDepartmentChange={handleDepartmentChange}
          selectedDepartment={selectedDepartment}
          selectedDegree={selectedDegree}
          handleDegreeChange={handleDegreeChange}
          draftCount={draftCount}
        />

        <EventDetails
          currentWeekStart={currentWeekStart}
          currentWeekEnd={currentWeekEnd}
          calendarRef={calendarRef}
          currentToggle={state.currentToggle}
          state={state}
          selectedYear={selectedYear}
          handleOccurrenceClick={handleOccurrenceClick}
          setState={setState}
          fetchEventsList={fetchEventsList}
          setListDate={setListDate}
          listDate={listDate}
          handleSortByChange={handleSortByChange}
          handleSingleEventClick={handleSingleEventClick}
          handleSearch={handleSearch}
          calenderData={calenderData}
          handleToggleChange={handleToggleChange}
          eventList={eventList}
          handleCategoryChange={handleCategoryChange}
          selectedCategory={selectedCategory}
          setIsDrawerVisible={setIsDrawerVisible}
          isDrawerVisible={isDrawerVisible}
          uniqueYears={uniqueYears}
          degreeOptions={degreeOptions}
          departmentOptions={departmentOptions}
          departmentOptionSet={departmentOptionSet}
          uniqueCategories={uniqueCategories}
          handleYearChange={handleYearChange}
          handleDepartmentChange={handleDepartmentChange}
          selectedDepartment={selectedDepartment}
          selectedDegree={selectedDegree}
          handleDegreeChange={handleDegreeChange}
          handleDrawerClose={handleDrawerClose}
          setRenderState={setRenderState}

        />


{(isDrawerVisible && (state.currentToggle === 'left' || state.eventStatus === "DRAFT" ))    && (
        <PreviewDrawer
          open={isDrawerVisible}
           onClose={handleDrawerClose}
          eventDetails={selectedEvent}
          setRenderState={setRenderState}
        />
      )}
        <ActionModal
          isModalVisible={isModalVisible}
          handleCloseModal={handleCloseModal}
          handleConfirmAction={handleConfirmAction}
          modalContent={modalContent}
        />

      </MainWrapper>
  )
}
export default Events
